module.exports = __webpack_public_path__ + "frontend-assets/img/Easter_animation_big_W_BG_HighQ.dc8c1ba4.gif";